import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { IAppSettings, II18n, IPostTypeOption } from './types';

const elements = document.querySelectorAll<HTMLElement>('.post-filters-archive');

elements.forEach((element) => {
	const root = createRoot(element);

	const apiBase = element.getAttribute('data-api-base');
	const blogId = element.getAttribute('data-blog-id');
	const postType = element.getAttribute('data-post-type');
	const multiPostType = element.getAttribute('data-multi-post-type') === '1';
	const availablePostTypes = element.getAttribute('data-available-post-types');
	const postsPerPage = element.getAttribute('data-posts-per-page');
	const filtersToShow = element.getAttribute('data-filters-to-show');
	const showSearch = element.getAttribute('data-show-search');
	const layout = element.getAttribute('data-layout');
	const searchTitle = element.getAttribute('data-search-title');
	const selectedTax = element.getAttribute('data-selected-tax');
	const addFiltersToUrl = element.getAttribute('data-add-filters-to-url');
	const addPageToUrl = element.getAttribute('data-add-page-to-url');
	const addSearchToUrl = element.getAttribute('data-add-search-to-url');
	const paginationType = element.getAttribute('data-pagination-type');
	const postAuthor = element.getAttribute('data-post-author');
	const postTypeOptions = element.getAttribute('data-post-type-options');
	const i18nAttr = element.getAttribute('data-i18n');

	const settings: IAppSettings = {
		apiBase: apiBase ?? '',
		blogId: null !== blogId ? +blogId : 1,
		postType: postType ?? 'post',
		multiPostType,
		availablePostTypes: availablePostTypes?.length ? availablePostTypes.split(',') : [],
		postTypeOptions:
			null !== postTypeOptions ? (JSON.parse(postTypeOptions) as IPostTypeOption[]) : [],
		postsPerPage: null !== postsPerPage ? +postsPerPage : 12,
		filtersToShow: filtersToShow?.length ? filtersToShow.split(',') : [],
		showSearch: !!showSearch,
		layout: layout ?? 'default',
		searchTitle: searchTitle ?? 'Search by keyword',
		initSelectedTax: null !== selectedTax ? JSON.parse(selectedTax) : {},
		addFiltersToUrl: !!addFiltersToUrl,
		addPageToUrl: !!addPageToUrl,
		addSearchToUrl: !!addSearchToUrl,
		paginationType: paginationType ?? 'numbered_pagination',
		postAuthor: postAuthor ?? '',
		i18n: null !== i18nAttr ? (JSON.parse(i18nAttr) as II18n) : ({} as II18n),
		element,
	};

	if (settings.apiBase.length) {
		root.render(
			<React.StrictMode>
				<App settings={settings} />
			</React.StrictMode>
		);
	}
});
